import React, { useState, useEffect } from 'react';

function SlotForm({ section, zoneId, onSave, onClose }) {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    role_id: '',
    shift: 'day',
    slot_number: ''
  });
  const [error, setError] = useState('');

  // Загружаем роли зоны
  useEffect(() => {
    fetch(`/api/zone-roles?zone_id=${zoneId}`)
      .then((r) => r.json())
      .then((data) => {
        setRoles(data);
        if (data.length > 0) {
          setForm((prev) => ({ ...prev, role_id: data[0].id }));
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [zoneId]);

  // Когда выбрали роль — вычисляем авто-номер
  useEffect(() => {
    if (!form.role_id) {
      setForm((prev) => ({ ...prev, slot_number: '' }));
      return;
    }
    fetch(`/api/slots?section_id=${section.id}&shift=${form.shift}`)
      .then((r) => r.json())
      .then((data) => {
        // Ищем максимум для этой роли
        const sameRole = data.filter((s) => s.role_id === parseInt(form.role_id));
        const maxNum = sameRole.length > 0 
          ? Math.max(...sameRole.map((s) => s.slot_number)) 
          : 0;
        setForm((prev) => ({ ...prev, slot_number: maxNum + 1 }));
      })
      .catch(() => {});
  }, [form.role_id, form.shift, section.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.role_id) {
      setError('Выберите роль');
      return;
    }

    onSave({
      section_id: section.id,
      role_id: parseInt(form.role_id),
      shift: form.shift,
      slot_number: form.slot_number ? parseInt(form.slot_number) : null
    });
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal modal-small" onClick={(e) => e.stopPropagation()}>
          <div className="modal-body" style={{ textAlign: 'center', padding: '40px' }}>
            ⏳ Загрузка ролей...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>➕ Добавить рабочее место</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="slot-form-info">
            <b>📍 {section.name}</b>
          </div>

          {roles.length === 0 ? (
            <div className="login-error">
              У этой зоны нет привязанных ролей. Обратитесь к администратору.
            </div>
          ) : (
            <>
              <div className="form-group">
                <label>Роль *</label>
                <select
                  value={form.role_id}
                  onChange={(e) => setForm({ ...form, role_id: e.target.value })}
                  required
                >
                  {roles.map((r) => (
                    <option key={r.id} value={r.id}>{r.name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Смена *</label>
                <div className="shift-radio-group">
                  <label className={`shift-radio ${form.shift === 'day' ? 'active' : ''}`}>
                    <input
                      type="radio"
                      name="shift"
                      value="day"
                      checked={form.shift === 'day'}
                      onChange={(e) => setForm({ ...form, shift: e.target.value })}
                    />
                    ☀️ День
                  </label>
                  <label className={`shift-radio ${form.shift === 'night' ? 'active' : ''}`}>
                    <input
                      type="radio"
                      name="shift"
                      value="night"
                      checked={form.shift === 'night'}
                      onChange={(e) => setForm({ ...form, shift: e.target.value })}
                    />
                    🌙 Ночь
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Номер места (авто, можно изменить)</label>
                <input
                  type="number"
                  min="1"
                  value={form.slot_number}
                  onChange={(e) => setForm({ ...form, slot_number: e.target.value })}
                  placeholder="Автоматически"
                />
              </div>

              {error && <div className="login-error">{error}</div>}

              <div className="modal-footer">
                <div className="modal-footer-right">
                  <button type="button" className="btn-cancel" onClick={onClose}>
                    Отмена
                  </button>
                  <button type="submit" className="btn-save">
                    Добавить
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default SlotForm;